import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { initBridge } from '@/bridge/embeddedBridge.ts';
import { useLaunchViewTrace } from '@/diag/launchTrace';

const TIMEOUT_MS = 10_000;

export function EmbeddedLoader() {
  const { t } = useTranslation('common');
  const [timedOut, setTimedOut] = useState(false);

  // [LAUNCH VIEW] A full-bleed flat fill with nothing on it for up to 10s — a strong candidate for
  // the owner's "black view" frames. Its SHOW/HIDE bracket says exactly how long it held the screen.
  useLaunchViewTrace('EmbeddedLoader', 'full-bleed blank; waits for Unity\'s project push');

  useEffect(() => {
    // assetSweep: this page is hosted by TimelineWebViewPanel, the one Unity host that answers
    // requestAssetManifest.
    initBridge(undefined, { assetSweep: true });
    const timer = setTimeout(() => setTimedOut(true), TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'var(--bg-primary)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      {timedOut && (
        <div style={{ textAlign: 'center', color: 'var(--text-secondary)', padding: 32 }}>
          <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 8 }}>
            {t('embeddedTimeoutTitle')}
          </div>
          <div style={{ fontSize: 13 }}>
            {t('embeddedTimeoutMessage')}
          </div>
        </div>
      )}
    </div>
  );
}
